import React from 'react';
import {Dialog, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {useTranslation} from "react-i18next";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

const RaSignedDialog = () => {
    const {t} = useTranslation(['network']);


    return (
        <Dialog
            open={true}
            onClose={() => {
            }}
            aria-labelledby="responsive-dialog-title"
            disableEscapeKeyDown={true}
        >
            <DialogTitle id="responsive-dialog-title" sx={{display: 'flex', justifyContent: 'center'}}>
                {t('digitalSign.step.END.popup.title')}
                <CheckCircleRoundedIcon color={'success'}/>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t('digitalSign.step.END.popup.description')}
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

export default RaSignedDialog;